export default "__VITE_ASSET__BLHt68Z9__"